module.exports = __webpack_public_path__ + "static/media/general-relocation.1a93936b.jpg";